var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc6f7068-4ee6-47ec-a00b-f81b06d0ab28",
    "data-name": "Transparent Bounding Box (Export)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e14f6a7b-a8ee-4d6e-a46d-8b060f40b595",
    "data-name": "Icon Design (Export)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,13H17V9H15v4H5a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V15A2,2,0,0,0,19,13ZM8,18H6V16H8Zm3.5,0h-2V16h2ZM15,18H13V16h2ZM12,5,11,3.67a8.34,8.34,0,0,1,10,0L20,5A6.63,6.63,0,0,0,12,5Zm7,1.34L18,7.67a3.3,3.3,0,0,0-4,0L13,6.34A5,5,0,0,1,19,6.34Z",
    fill: "#000001"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem);
export default __webpack_public_path__ + "static/media/modem.dd7c759f3c51875598451953b3acc721.svg";
export { ForwardRef as ReactComponent };